import api from "@/helpers/api_helper";
import qs from 'qs';

interface ProductOptionSetting {
    optionKey: string,
    optionValue: string[]
}

interface ProductOptionResult {
    mallProductId?: string,
    options: {
        optionKey: string,
        optionValue: string,
    }[],
    additionalPrice: number,
    inventory: number,
    isPublic: boolean,
    isForSale: boolean,
}

export interface PostProductRequestBody {
    productTitle: string,
    productPrice: number,
    discountMethod?: 'won' | 'percent',
    discountValue?: number,
    representImageUrl: string,
    productImageUrl: string[],
    description: string,
    productTags: string[],
    mallShippingPolicyId: string,
    totalInventory?: number,
    isOptions: boolean,
    optionsSettings?: ProductOptionSetting[],
    optionsResult?: ProductOptionResult[],
}

export interface PatchProductRequestBody {
    productTitle?: string,
    productPrice?: number,
    discountMethod?: 'won' | 'percent',
    discountValue?: number,
    representImageUrl?: string,
    productImageUrl?: string[],
    description?: string,
    productTags?: string[],
    mallShippingPolicyId?: string,
    totalInventory?: number,
    isOptions?: false,
    isForSale?: boolean;
    isPublic?: boolean;
}

export const postProduct = async (mallId: string, data: PostProductRequestBody) => {
    try {
        await api.post(`/mall/${mallId}/product`, data);
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e;
        }
    }
}

export interface GetProductParams {
    limit: number,
    offset: number,
    searchKey?: 'keyword' | 'tag',
    searchValue?: string,
    sortKey?: 'salesAmount' | 'isForSale' | 'isPublic' | 'inventory' | 'createdAt',
    sortValue?: 'ASC' | 'DESC',

}
export const getProductList = async (mallId: string, queryParams?: GetProductParams) => {
    try {
        // queryParams = queryParams && queryParams.offset && queryParams.limit ? queryParams : {offset:0, limit:15};
        const offset = queryParams?.offset || 0;
        const limit = queryParams?.limit || 15;

        queryParams = {
            offset: offset,
            limit: limit,
            sortKey: 'createdAt',
            sortValue: 'DESC',
            ...queryParams,
        }

        const queryStr = qs.stringify(queryParams);
        console.log('getProductList-queryStr', queryStr)

        return await api.get(`/mall/${mallId}/product?${queryStr}`).then(r => {
            return {
                list: r.data?.productList || [],
                total: r.data?.totalCount || 0,
            }
        })
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e;
        }
    }
}

export const getProduct = async (mallId: string, productId: string) => {
    try {
        return await api.get(`/mall/${mallId}/product/${productId}/settings`).then(r => {
            return r.data?.productInfo || r.data || {}
        })
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e;
        }
    }
}

export const putProduct = async (mallId: string, productId: string, data: PostProductRequestBody) => {
    try {
        await api.put(`/mall/${mallId}/product/${productId}`, data);
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e;
        }
    }
}

export const patchProduct = async (mallId: string, productId: string, data: PatchProductRequestBody) => {
    try {
        await api.patch(`/mall/${mallId}/product/${productId}`, data);
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            throw e;
        }
    }
}
export type RealTimeInventoryType = {
    productAmount: {
        id: string;
        completedAmount: number;
        inventory: number;
        name: string;
        proceedAmount: number;
        waitingAmount: number;
    }[];
    totalAmount: {
        completedAmount: number;
        inventory: number;
        proceedAmount: number;
        waitingAmount: number;
    }
    unitAmount: any
}
export const getInventoryRealtimeData = async (mallId: string, productGroupId: string): Promise<RealTimeInventoryType> => {
    try {
        return await api.get(`/mall/${mallId}/product/${productGroupId}/inventory`).then(r => r.data.item)
    } catch (e: any) {
        if (typeof e === 'string') {
            throw {
                message: e,
            }
        } else {
            if (e?.place_holder || e?.data?.place_holder) {
                throw {
                    ...e,
                    placeHolder: e.data?.place_holder || e.place_holder,
                }
            } else {
                throw e;
            }
        }
    }
}

export const deleteProduct = async (mallId: string, representProductId: string) => {
    try {
        return await api.delete(`/mall/${mallId}/product/${representProductId}`)
    } catch (error) { throw error }
}
export const duplicateProduct = async (mallId: string, representProductId: string) => {
    try {
        return await api.post(`/mall/${mallId}/product/${representProductId}/copy`)
    } catch (error) { throw error }
}